import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import AuthCardLayout from "./AuthCardLayout";

const Success = () => {
  const route = all_routes;
  return (
    <AuthCardLayout
      icon="ti-circle-check"
      tone="success"
      title="Password Reset Successful"
      subtitle="Your password has been reset successfully. You can now sign in with your new password."
      showBackToLogin={false}
    >
      <Link
        to={route.login}
        className="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center"
      >
        <i className="ti ti-login me-2" />
        Back to Login
      </Link>
    </AuthCardLayout>
  );
};

export default Success;
